<template>
  <div class="login-form">
    <div class="img" style="width: 50%; height: 100%; flex-shrink: 0">
      <!-- <img :src="bkImg" style="width: 100%; height: 100%; flex-shrink: 0" /> -->
    </div>
    <img class="bgimg" :src="bkImg" style="height: 100%;" />
    <div class="login-input" style="width: 50%; height: 100%; flex-shrink: 0">
      <div class="login-box" style="width: 50%;">
        <div class="title">
          <span :class="{ 'active': active === 1 }" @click="active = 1">账 号 登 录</span>
          <span :class="{ 'active': active === 2 }" @click="active = 2">APP 下 载</span>
        </div>
        <el-form v-show="active === 1" :model="dataForm" :rules="dataRule" size="medium" ref="dataForm"
          @keyup.enter.native="dataFormSubmit()" style="width: 452px; margin-top: 4vh">
          <el-col :span="24">
            <span class="label">账 号</span>
            <el-form-item prop="mobilePhone">
              <el-input v-model="dataForm.mobilePhone" autocomplete="off" style="width: 100%"
                placeholder="请输入您的登录账号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <span class="label">密 码</span>
            <el-form-item prop="password">
              <el-input v-model="dataForm.password" autocomplete="off" style="width: 100%;padding-right:50px" type="password"
                placeholder="请输入您的登录密码" show-password></el-input>
            </el-form-item>
          </el-col>
          <div class="check">
            <el-checkbox v-model="dataForm.checked">记住账号密码</el-checkbox>
            <el-button class="login-btn-submit" type="warning" @click="dataFormSubmit()" :loading="isHttpLoading" round>
              登 录
            </el-button>
          </div>
        </el-form>
        <div v-show="active === 2" class="code">
          <div>
            <img :src="androidImg">
            <div class="text">Android</div>
          </div>
          <div>
            <img :src="iosImg">
            <div class="text">IOS</div>
          </div>
        </div>
      </div>
      <a class="number" target="_blank" href="https://beian.miit.gov.cn">{{projectConfig.filingNumber}}</a>
    </div>
  </div>
</template>

<script>
import { SystemController } from '@/api';
import { mapMutations } from 'vuex';
import projectConfig from '@/core/config';
import { encrypt, setToken } from '@/utils';

export default {
  data() {
    return {
      bkImg: require('@/assets/img/login-image.png'),
      iosImg: require("@/assets/img/ios.png"),
      androidImg: require("@/assets/img/android.png"),
      dataForm: {
        mobilePhone: '',
        password: '',
        checked: false
      },
      dataRule: {
        mobilePhone: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      projectConfig,
      projectName: projectConfig.projectName,
      active: 1
    };
  },
  created() {
    if (localStorage.getItem('user')) this.dataForm = JSON.parse(localStorage.getItem('user'))
  },
  methods: {
    handleClick() {
      this.$router.replace({ name: 'privacy' });
    },
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },
    login() {
      let params = {
        loginName: this.dataForm.mobilePhone,
        password: encrypt(this.dataForm.password)
      };

      SystemController.login(this, params, null, { showMask: false })
        .then((data) => {
          data.data.menuList = data.data.menuList.filter(item => item.menuName.split('(模板').length < 2 && item.menuName !== 'app')
          this.setMenuList(data.data.menuList);
          if (this.dataForm.checked) {
            localStorage.setItem('user', JSON.stringify(this.dataForm))
          } else {
            localStorage.removeItem('user')
          }
          delete data.data.menuList;
          this.setUserInfo(data.data);
          setToken(data.data.tokenData);
          this.setCurrentMenuId(null);
          this.$router.replace({ name: 'main' });
        })
        .catch((e) => { });
    },
    ...mapMutations(['setUserInfo', 'setMenuList', 'setCurrentMenuId'])
  },
  mounted() {
    this.setMenuList([]);
    this.setUserInfo({});
    setToken();
  }
};
</script>

<style lang="scss">
.login-form {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .bgimg{
    position: absolute;
    left: 0;
    max-width:50%;
  }
  .img {
    position: relative;

    .name {
      position: absolute;
      top: 40%;
      left: 25%;
      margin-top: -5px;

      img {
        width: 70px;
      }

      span {
        font-size: 50px;
        color: #204c97;
        position: relative;
        top: -15px;
      }

    }
  }
  .code{
    display:flex;
    justify-content:space-between;
    height:400px;
    &>div{
      width:40%;
      text-align:center;
      img{
        width:100%;
      }
      .text{
        font-weight:700;
        font-size:20px;
      }
    }
  }
  .login-input {
    position: relative;

    .login-box {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .title {
        width: 100%;
        margin-bottom: 70px;
        display: flex;
        justify-content: space-between;
        span {
          // width: 40%;
          font-size: 33px;
          font-weight: normal;
          cursor: pointer;
          color: rgba(152, 151, 156, 1);
        }

        .active {
          color: #204c97;
        }
      }

      .label {
        width: 163px;
        height: 34px;
        font-size: 26px;
        font-weight: normal;
        color: #204c97;
        display: inline-block;
        margin-bottom: 25px;
        margin-top: 20px;
      }

      .check {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 32px;

        .el-checkbox__label {
          font-size: 20px;
          font-weight: normal;
          color: #98979c;
        }

        .el-checkbox__inner {
          width: 20px;
          height: 20px;
          border-radius: 8px;
          margin-top: -5px;
        }

        .el-checkbox__inner::after {
          height: 8px;
          left: 7px;
          top: 3px;
          border: 2px solid #ffffff;
          border-left: 0;
          border-top: 0;
        }
      }

      .login-btn-submit {
        background-color: #204C97;
        padding: 0 40px;
        border: 1px solid #204C97;
      }

      .el-input {
        input {
          border-radius: 30px;
          width: 452px;
          height: 60px;
          font-size: 25px;
          padding-left: 30px;
        }
      }

      input::placeholder {
        font-size: 25px;
        font-family: Arial;
        letter-spacing: 5px;
        color: #919191 !important;
        padding-left: 13px;
        padding-top: 15px;
        line-height: 60px;
      }
    }
  }
  .number{
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
    color:#999;
    text-decoration:none;
  }
}
.el-input--medium .el-input__icon {
    line-height: 58px !important;
    font-size: 30px !important;
    margin-right: 18px;
}
.login-form .el-input__inner {
  // height: 45px !important;
  padding-right: 50px !important;
}

.login-form .el-button {
  height: 45px !important;
  font-size: 20px;
}

.privacy {
  // position: absolute;
  // bottom: 50px;
  // right: 30%;
  text-decoration: none;
}

.login-box {

  .el-form-item__error {
    font-size: 22px !important;
  }
}
</style>
